// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d293179","453":"ab93889e","732":"ec8970a2"}[chunkId] + ".chunk.js";
};